// Manning Scheduleで利用するマスターデータを取得するサービス
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import moment from "moment-timezone";

// 配乗可能なクルー一覧を取得するリポジトリ
const enterpriseManningVesselRolePositionRepository = AiseaApiFactory.get(
  "enterpriseManningVesselRolePosition"
);

// 配乗可能船員取得サービス
const EnterpriseManningVesselRolePositionService = (() => {
  let _assignableCrews = null;

  const fetch = async (rolePositionId, date) => {
    const queryparam = {
      date: moment(date).format("YYYY-MM-DD"),
    };

    const res = await enterpriseManningVesselRolePositionRepository.fetchByRolePostionId(
      rolePositionId,
      queryparam
    );
    if (!res || !res.status) {
      throw res;
    }

    _assignableCrews = res.data;

    return _assignableCrews;
  };

  const getAssignableCrews = () => {
    if (!_assignableCrews) {
      return [];
    }
    return _assignableCrews.crews;
  };

  return { fetch, getAssignableCrews };
})();

export { EnterpriseManningVesselRolePositionService };
